import { ListBulletIcon, Squares2X2Icon } from "@heroicons/react/20/solid";
import type { ViewMode } from "@via/pages/pipelines/view-mode.ts";
import type { JSX } from "react";

interface ViewModeToggleProps {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const OPTIONS: {
  mode: ViewMode;
  label: string;
  Icon: typeof ListBulletIcon;
}[] = [
  { mode: "cards", label: "Cards", Icon: Squares2X2Icon },
  { mode: "list", label: "List", Icon: ListBulletIcon },
];

export default function ViewModeToggle({
  mode,
  onChange,
}: ViewModeToggleProps): JSX.Element {
  return (
    <div className="inline-flex rounded-md shadow-sm" role="group">
      {OPTIONS.map(({ mode: optionMode, label, Icon }) => (
        <button
          key={optionMode}
          type="button"
          aria-pressed={mode === optionMode}
          aria-label={label}
          title={label}
          onClick={() => onChange(optionMode)}
          className={`px-2.5 py-1.5 ring-1 ring-inset ring-gray-300 first:rounded-l-md last:rounded-r-md ${
            mode === optionMode
              ? "bg-indigo-600 text-white"
              : "bg-white text-gray-500 hover:bg-gray-50"
          }`}>
          <Icon className="h-5 w-5" aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
